import axiosInstance from '../api';
import {
  offerRounds,
  RoundStatus,
  InitiatorType,
  Prisma,
} from '@prisma/client';

export interface CreateOfferRoundData {
  offerId: string;
  price: number;
  closingDate: Date;
  earnestMoney?: number;
  concessions?: number;
  appliances?: boolean;
  inspectionPeriod?: number;
  contingent?: boolean;
  bagentComm?: number;
  loan?: number;
  homeWarrantyType?: 'NONE' | 'SELLER' | 'BUYER';
  termiteInspection?: boolean;
  termiteBond?: boolean;
  sewerInspection?: boolean;
  newSurvey?: boolean;
  additionalTerms?: string;
  paymentMethod: string;
  responseNotes?: string;
  expirationDays?: number;
}

export type OfferRoundWithRelations = Prisma.offerRoundsGetPayload<{
  include: {
    initiator: true;
    offer: {
      include: {
        user: true;
        listings: true;
      };
    };
  };
}>;

const offerRoundsService = {
  find: async (
    offerId: string,
    token?: string
  ): Promise<OfferRoundWithRelations[]> => {
    const res = await axiosInstance.get('/offer-rounds', {
      params: { offerId, ...(token && { token }) },
    });
    return res.data;
  },

  get: async (id: string, token?: string): Promise<OfferRoundWithRelations> => {
    const res = await axiosInstance.get(`/offer-rounds/${id}`, {
      params: token ? { token } : undefined,
    });
    return res.data;
  },

  create: async (
    data: CreateOfferRoundData,
    token?: string
  ): Promise<OfferRoundWithRelations> => {
    const res = await axiosInstance.post('/offer-rounds', data, {
      params: token ? { token } : undefined,
    });
    return res.data;
  },

  accept: async (
    id: string,
    token?: string
  ): Promise<OfferRoundWithRelations> => {
    const res = await axiosInstance.patch(
      `/offer-rounds/${id}`,
      {
        status: RoundStatus.ACCEPTED,
      },
      {
        params: token ? { token } : undefined,
      }
    );
    return res.data;
  },

  reject: async (
    id: string,
    token?: string
  ): Promise<OfferRoundWithRelations> => {
    const res = await axiosInstance.patch(
      `/offer-rounds/${id}`,
      {
        status: RoundStatus.REJECTED,
      },
      {
        params: token ? { token } : undefined,
      }
    );
    return res.data;
  },

  counter: async (
    id: string,
    data: CreateOfferRoundData,
    token?: string
  ): Promise<OfferRoundWithRelations> => {
    // First mark current round as countered
    await axiosInstance.patch(
      `/offer-rounds/${id}`,
      {
        status: RoundStatus.COUNTERED,
      },
      {
        params: token ? { token } : undefined,
      }
    );

    // Then create new round
    const res = await axiosInstance.post('/offer-rounds', data, {
      params: token ? { token } : undefined,
    });
    return res.data;
  },
};

export default offerRoundsService;
